import React from 'react';
import { Box, Skeleton, Grid } from '@mui/material';

type SkeletonCardProps = {
  height?: number;
  width?: string;
  minWidth?: number;
  minHeight?: number;
};

function SkeletonCard({
  height = 260,
  minHeight = 250,
  width = '100%',
  minWidth = 350,
}: SkeletonCardProps) {
  return (
    <Grid
      item
      container
      minHeight={minHeight}
      padding={2}
      paddingTop={3}
      direction='column'
      justifyContent='space-between'
      border={(theme) => `1px solid ${theme.palette.borderColor}`}
      bgcolor='white'
      borderRadius='10px'
      height={height}
      width={width}
      minWidth={minWidth}
    >
      <Box
        display={'flex'}
        flexDirection={'row'}
        justifyContent='space-between'
        alignItems='center'
      >
        <Box width='50%' display='flex' alignItems='center'>
          <Skeleton
            variant='rounded'
            width={60}
            height={60}
            sx={{ borderRadius: '10px' }}
          />
          <Box
            display={'flex'}
            flexDirection={'column'}
            gap={0.1}
            marginLeft={2}
            flex={1}
          >
            <Skeleton variant='text' sx={{ fontSize: '1.3rem' }} width='100%' />
            <Skeleton variant='text' sx={{ fontSize: '0.7rem' }} width='100%' />
          </Box>
        </Box>
        <Skeleton variant='rounded' width={20} height={20} />
      </Box>
      <Box display={'flex'} flexDirection={'column'} gap={2}>
        <Skeleton variant='text' sx={{ fontSize: '1.3rem' }} width={130} />
        <Skeleton variant='text' sx={{ fontSize: '0.5rem' }} width={100} />
        <Skeleton variant='text' sx={{ fontSize: '0.5rem' }} width={100} />
      </Box>
      <Box display={'flex'} justifyContent='space-between'>
        <Skeleton
          variant='rounded'
          width={70}
          height={30}
          sx={{ borderRadius: '25px' }}
        />
        <Skeleton variant='text' sx={{ fontSize: '1.3rem' }} width={50} />
      </Box>
    </Grid>
  );
}

export default SkeletonCard;
